//@ts-ignore
import {useState, useMemo, useCallback} from 'react'
import {useAppSelector, useAppDispatch} from '../../hooks/redux'
import {getSubjectId} from '../biomarkers/[id]/IndicatorsAndSignals'
import {LeftNavbar} from '../subjects/Subject'
import {CreateIndicator, NavBarContainer, LeftSide, NavElement} from '../subjects/Subject.style'
import AddIcon from '@mui/icons-material/Add'
import InterpretationMainTable from '../../components/tables/main/interpretation/InterpretationTable'
import SubjectEdit from '../subjects/SubjectEdit'
import {MAX_PER_PAGE} from '../../constants/other'
import {TableFilter} from '../../components/myTable/MyTable'
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField} from '@mui/material'
import {updateCurrent} from '../../redux/slice/currentItem'

const InterpretationsLIst = (props) => {
    const {interpretations, isLoading} = useAppSelector((state) => state.data)
    const {currentItem} = useAppSelector((state) => state)
    const dispatch = useAppDispatch()

    const [language, setLanguage] = useState('en')
    const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false)
    const [selectedNewLanguage, setSelectedNewLanguage] = useState('')

    let [filter, setFilter] = useState({
        sort: '_id',
        perPage: 10, // Используем 10 для интерпретаций как указано в API
        search: '',
        direction: '_id',
        page: 1,
        // filter: {_id: 1}
    })
    let onConnect = props.onConnect

    const availableLanguages = useMemo(() => {
        const name = currentItem?.data?.name
        return name && typeof name === 'object' ? Object.keys(name) : ['en']
    }, [currentItem?.data?.name])

    const handleRemoveLanguage = useCallback((langToRemove) => {
        if (availableLanguages.length <= 1) {
            alert('Cannot remove the last language')
            return
        }
        
        if (langToRemove === 'en') {
            alert('Cannot remove English language')
            return
        }
        
        if (window.confirm(`Are you sure you want to remove language "${langToRemove.toUpperCase()}"?`)) {
            const updatedName = { ...currentItem?.data?.name }
            delete updatedName[langToRemove]
            
            const updatedDescription = { ...currentItem?.data?.description }
            delete updatedDescription[langToRemove]
            
            dispatch(updateCurrent({
                name: updatedName,
                description: updatedDescription
            }))
            
            if (language === langToRemove) {
                setLanguage('en')
            }
        }
    }, [availableLanguages.length, currentItem?.data?.name, currentItem?.data?.description, dispatch, language])

    const handleAddLanguage = useCallback(() => {
        const code = selectedNewLanguage.toLowerCase().trim()
        if (!code || code.length > 2 || availableLanguages.includes(code) || !currentItem?.data) return

        const newNameObj =
            typeof currentItem.data.name === 'object'
                ? { ...currentItem.data.name, [code]: '' }
                : { en: currentItem.data.name || '', [code]: '' }

        const newDescriptionObj =
            typeof currentItem.data.description === 'object'
                ? { ...currentItem.data.description, [code]: '' }
                : { en: currentItem.data.description || '', [code]: '' }

        dispatch(updateCurrent({ name: newNameObj, description: newDescriptionObj }))
        setLanguage(code)
        setIsAddLanguageModalOpen(false)
        setSelectedNewLanguage('')
    }, [dispatch, selectedNewLanguage, availableLanguages, currentItem])

    return (
        <div>
            {/* Language Switcher */}
            <LeftSide style={{ justifyContent: 'flex-start', marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                {availableLanguages.map((lang, index) => (
                    <div key={lang} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginRight: index < availableLanguages.length - 1 ? 8 : 0 
                    }}>
                        <NavElement
                            as="span"
                            selected={language === lang}
                            onClick={() => setLanguage(lang)}
                            style={{ cursor: 'pointer', marginRight: 4 }}
                        >
                            {lang.toUpperCase()}
                        </NavElement>
                        {lang !== 'en' && availableLanguages.length > 1 && (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleRemoveLanguage(lang)
                                }}
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#ff4444',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}
                            >
                                ×
                            </span>
                        )}
                    </div>
                ))}
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setIsAddLanguageModalOpen(true)}
                    style={{ marginLeft: 8, fontSize: '12px', padding: '4px 8px' }}
                >
                    + Add Language
                </Button>
            </LeftSide>

            <SubjectEdit language={language}/>
            <LeftNavbar/>
            <InterpretationMainTable language={language}/>
            
            {/* Add Language Modal */}
            <Dialog open={isAddLanguageModalOpen} onClose={() => setIsAddLanguageModalOpen(false)}>
                <DialogTitle>Add New Language</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Language Code"
                        value={selectedNewLanguage}
                        onChange={(e) => setSelectedNewLanguage(e.target.value)}
                        placeholder="e.g., fr, es, ru"
                        inputProps={{ maxLength: 2 }}
                        style={{ marginTop: 16 }}
                        helperText="Enter 2-letter language code (e.g., fr for French, es for Spanish)"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddLanguageModalOpen(false)}>Cancel</Button>
                    <Button
                        onClick={handleAddLanguage}
                        variant="contained"
                        disabled={
                            !selectedNewLanguage ||
                            selectedNewLanguage.length > 2 ||
                            availableLanguages.includes(selectedNewLanguage.toLowerCase())
                        }
                    >
                        Add Language
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default InterpretationsLIst

{
    /* <div></div>

  <small>Direction</small>
  <input
    value={filter.direction}
    onChange={(e) =>
      setFilter({ ...filter, direction: e.target.value, page: 1 })
    }
  />
  <div></div>
  <small>Sort</small>
  <input
    value={filter.sort}
    onChange={(e) =>
      setFilter({ ...filter, sort: e.target.value, page: 1 })
    }
  />
  <div></div>

  <small>Search</small>
  <input
    value={filter.search}
    onChange={(e) =>
      setFilter({ ...filter, search: e.target.value, page: 1 })
    }
  />
  <div></div>

  <small>Filter Id</small>
  <input
    value={(filter.filter || {})._id}
    onChange={(e) =>
      setFilter({ ...filter, filter: { _id: e.target.value }, page: 1 })
    }
  /> */
}
